import { kBoxAuthorizePath } from '@/constants/constants-api-paths'
import getExternalStorageAuthorizeUrl from '@/settings/fetch/get-external-storage-authorize-url'
import { ExternalStorageAuthorizeResponse } from '@/settings/schemas/external-storage-schema'

export default async function getBoxAuthorizeUrl(): Promise<ExternalStorageAuthorizeResponse> {
  return getExternalStorageAuthorizeUrl(kBoxAuthorizePath)
}
